/**
 * User: hella
 * Date: 3/30/14
 * Time: 2:54 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * merged global/utils/conversions.numbers.js and global/utils/number.js together in this file
 * moved from .com/dibs/assets/js/global/utils/commonjs/numberConversions.js
 */

'use strict';

var _ = require('underscore');
var strings = require('./strings');
var currencyUtil = require('dibs-currency-helpers/util');
var intelligentFormat = require('dibs-currency-helpers/intelligentFormat');
var currencyToInteger = require('dibs-currency-helpers/util').currencyToInteger;
var currencies = require('./dibsConstants').currency;
var FinancialAmounts = require('bunsen/models/FinancialAmount');
var currencySymbols = currencies.symbols;

var FEET = 12;
var measurements;


measurements = {
    inch: {
        toCm: function (x) {
            return x * 2.54;
        },
        toFeet: function (x) {
            var ret;
            var feet;
            var inches;
            var realFeet;
            if (x <= 48) {
                ret =  x + '"';
            } else {
                realFeet = x / FEET;
                ret = realFeet + "'";
                if (realFeet % 1 !== 0) {
                    feet = Math.floor(realFeet);
                    inches = Math.round((realFeet - feet) * FEET);
                    ret = feet + "' " + inches + '"';
                }
            }
            return ret;
        }
    },
    cm: {
        toInch: function (x) {
            return x * 0.3937;
        }
    },
    feet: {
        toInch: function (x) {
            var ret = 0;
            // looking for single quote
            var ftIndex = x.indexOf("'");
            // looking for double quote
            var inchIndex = x.indexOf('"');
            var ft;
            var inch;
            if (ftIndex !== -1) {
                ft = parseInt(x.substring(0, ftIndex), 10);
                ret += (ft * FEET);
            }

            if (inchIndex !== -1) {
                inch = parseInt(x.substring(ftIndex + 1, inchIndex), 10);
                ret += inch;
            }
            return ret;
        },
        toLongForm: function (x) {
            return x.replace("'", " ft. ").replace('"', " in.");
        },
        toShortForm: function (x) {
            return x.replace(" ft. ", "'").replace(" in.", '"');
        }
    }
};

/**
 * @param {number} num The number to add the commas to
 * @param {string} delim To use as thousands separator
 * @returns {string}
 */
exports.addThousandsDelim = function (num, delim) {
    delim = delim || ',';
    // only add commas if number has 4 or more digits
    return num < 1000 ? num.toString() : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delim);
};

exports.getCurrencySymbol = function (code) {
    return currencySymbols[code];
};

/**
 * @param {number} num The number to add the currency symbol to
 * TODO: update any `addCurrency` references to use three letter currency code
 * @param {string} type A key from the currencySymbol map
 * @returns {number|string}
 */
exports.addCurrency = function (num, type) {
    if (!(/^\d/).test(num) || !currencySymbols[type]) {
        return num;
    }
    return currencySymbols[type] + num;
};

/**
 * Removes commas from a string
 * @param {string} num A string with commas in it
 * @param {string} [delim] To use as thousands separator
 * @returns {number}
 */
exports.removeThousandsDelim = function (num, delim) {
    delim = delim || ',';
    var regex = new RegExp('\\' + delim, 'g');
    // make sure to return a true number
    // replace the delimiter:
    // 1.000.000 => 1000000
    return Number(num.toString().replace(regex, ""));
};

/**
 * @param {string} amount The currency value
 * @param {string} [type] A key from the currencySymbol map, defaults to dollar
 * @returns {string}
 */
exports.removeCurrency = function (amount, type) {
    amount += ''; // type conversion
    var symbol = currencySymbols[type] || currencySymbols.usd;
    var startPoint = amount.indexOf(symbol);
    var length = symbol.length;
    return startPoint > -1 ? amount.substring(startPoint + length) : amount;
};

/**
 * Converts a monetary value into either a number or a string with the appropriate
 * currency sign Also converts measurement values
 * @param {number|string} num The value to convert from a string -> number or number -> currency value
 * @param {string} [to] Type of value to convert x to ("number", "dollar", "euro", "gb-pounds")
 *                      Note: for measurement conversions, to field is converted to "toX" format to increase
 *                      readability of measurement object
 *                      i.e. if to arg = "cm" the key for look-up in the measurement object will
 *                      be converted to "toCm"
 * @param {string} [from] Type of value to convert x from
 *                        ("currency" to "number, dollar, etc."
 *                        | "number" to "dollar, etc."
 *                        |"inch" to "cm"
 *                        |"feet", "cm" to "inch", "feet" to "long_form").
 * @returns {Number/String}
 */
exports.convert = function convertMonetarySymbol(num, from, to) {
    if (!num && typeof num !== 'number') {
        return num;
    }

    to = to || "number";
    from  = from || "currency";

    if (from === "currency" && to === "number") {
        console.warn('This currency to number conversion is deprecated, please use dibs-currency-helpers');
        num = currencyToInteger(num);
    } else if (from === "number" && FinancialAmounts['CURRENCY_' + to.toUpperCase()]) {
        console.warn('This number to currency conversion is deprecated, please use dibs-currency-helpers');
        num = intelligentFormat(num, to);
    } else if (from !== "currency") {
        to = "to" + strings.capitalize(to);
        if (typeof measurements[from][to] === "function") {
            num = measurements[from][to](num);
            if (typeof num === "number") {
                num = Math.round(num * 100) / 100;
            }
        }
    }
    return num;
};

/**
 * Cash Format
 * @param number
 * @param {Boolean} showDecimal Defaults to True
 * @param {String} thousandsSeparator Defaults to ,
 * @param {String} decimalMark Defaults to .
 */
exports.cashFormat = function cashFormat(number, showDecimal, thousandsSeparator, decimalMark) {
    showDecimal = showDecimal === undefined || !!showDecimal;
    number = exports.format(number, showDecimal ? 2 : 0, thousandsSeparator, decimalMark);
    return currencySymbols.usd + number;
};

/**
 *
 * @param {number} number The number to format
 * @param {object} [options] Formatting options
 * @param {boolean} [options.showDecimal] Show a decimal or not. Defaults to true
 * @param {string} [options.thousandsSeparator] What separates the thousands? Defaults to comma ","
 * @param {string} [options.decimalMark] What separates decimals? Defaults to period "."
 * @param {string} [options.currencySymbol] Which currency symbol to use. Defaults to USD "$"
 * @returns {string}
 */
exports.localizedCashFormat = function (number, options) {
    // , showDecimal, thousandsSeparator, decimalMark
    options = _.extend({
        includeCurrencySymbol: true
    }, options);
    var decimalsToShow = options.showDecimal === false ?  0 : 2;
    var thousandsSeparator = options.thousandsSeparator || ',';
    var decimalMark = options.decimalMark || '.';
    var currencySymbol = options.currencySymbol || '$';

    number = exports.format(number, decimalsToShow, thousandsSeparator, decimalMark);
    currencySymbol = options.includeCurrencySymbol ? currencySymbol : '';

    // if it's negative we need to put the negative sign in front
    if (number.indexOf('-') !== -1) {
        return '- ' + currencySymbol + number.replace('-', '');
    }
    return currencySymbol + number;
};

exports.parseFloat = currencyUtil.parseFloat;

/**
 * Floating-point safe equals comparison
 * @param number
 * @param another_number
 * @returns {boolean}
 */
exports.isEqualFloat = function (number, anotherNumber) {
    return Math.abs(exports.parseFloat(number) - exports.parseFloat(anotherNumber)) < 0.000001;
};

exports.round = currencyUtil.round;

exports.format = currencyUtil.format;

exports.intelligentFormat = intelligentFormat;
/**
 * Takes a European style formatted number (periods for thousand sep., commas for decimal sep.)
 * and converts it to US style formatted number (commas for decimal sep., periods for thousands sep.)
 * @param price {string}
 */
exports.eurToUSPriceFormat = function (price) {
    var parts = (price || "").split(",");
    var cents = parts.length === 2 ? parts.pop() : "";
    //rest contains the non cents part of the price
    var rest = parts.pop();

    //replace periods with commas in non-cent section
    rest = rest.replace(/\./g, ",");

    //join cents and dollars with a period, it's the 'merican way.
    return cents ? [rest, cents].join(".") : rest;
};

/**
 * Checks if userCurrency is Euros and converts it to dollar format
 * Then parses value into number
 * @param value String
 * @param currency String
 */
exports.normalizeCurrencyFormat = function (value, currency) {
    var formatted = currency === FinancialAmounts.CURRENCY_EUR ? exports.eurToUSPriceFormat(value) : value;
    return exports.parseFloat(formatted);
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/numberConversions.js
// module id = 326
// module chunks = 64